
import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Cascader,
} from 'element-ui';
import { IQuesSearch } from '@/types/question.d';
import api from '@/api/question';
import Util from '@/libs/util';


@Component({
  components: {
    Form,
    FormItem,
    Input,
    Cascader,
  },
})
export default class SearchForm extends Vue {
  private form: IQuesSearch = {
    title: '',
    courseType: [],
    courseStep: [],
  };

  private options: { [key: string]: Array<object> } = { tidOpts: [], cidOpts: [] };

  public $refs!: {
    form: Form,
  };

  created() {
    this.getCourseType();
  }

  /**
   * @author liangyongmou
   * @description 获取课程类型
   */
  getCourseType() {
    api.getCourseType().then((res: any) => {
      this.options.tidOpts = Util.CompTreeNode(res, 'children');
    });
  }

  /**
   * @author liangyongmou
   * @description 获取课程章节
   */
  getCourseByType(tid: string) {
    api.getCourseByType(tid).then((res: any) => {
      this.options.cidOpts = res.map((em: any) => ({ id: em.id, children: em.chapters, name: `${em.name} ${em.version ? em.version : ''}` }));
    });
  }

  /**
   * @author liangyongmou
   * @description 课程章节改变事件
   * @param { v } 课程章节id
   */
  handleTidChange(v: Array<any>) {
    if (v.length > 0) {
      this.getCourseByType(v[1]);
    } else {
      this.options.cidOpts = [];
    }
  }

  /**
   * @author liangyongmou
   * @description  接收普通搜索的值
   * @param { searchValue } 普通搜索的值
   */
  setTitle(searchValue: string) {
    this.form.title = searchValue;
  }

  /**
   * @author liangyongmou
   * @desc 获取查询数据
   */
  getFormData() {
    return this.form;
  }

  /**
   * @author liangyongmou
   * @description 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
    this.options.cidOpts = [];
  }
}
